export default {
  row: {
    margin: '16px 0 0',
    '&:first-child': {
      margin: '0'
    }
  },
  small: {
    margin: '10px 0 0'
  },
  left: {
    textAlign: 'left'
  },
  inline: {
    display: 'flex',
    alignItems: 'center'
  }
}
